export const getElcoConf = (confID) => {
    let conf = {}

    conf['hp-nl'] = {
        infoCookieZone: false,
        oneIMode: true,
        switchMobileToDesktop: {
            activate: true
        },
        genericHeaderZone: false,
        navStickyZone: true,
        noBtnSearch: true,
        unifiedSearchEngine: {
            label: "Rechercher sur Orange",
            queryAdditionalParams: "module=orange&bhv=occ",
            toptrend118712: true,
            toptrend: true,
            toptrendCategory: "orange.actu",
            tracking: {
                category: "top_search",
                action: "search"
            }
        },
        tracking: {
            refz: {
                service: "acc-digital",
                // page: "prospect-nl"
            },
            Tealium: {
                idBased: true
            }
        },
        footer: {
            id: "footer-wrapper",
            syndicationZone: true,
            sitemapZone: true,
            pushBoutiqueZone: false
        }
    }

    conf['hp-mob-nl'] = {
        infoCookieZone: false,
        oneIMode: true,
        genericHeaderZone: true,
        serviceZone: true,
        searchZone: true,
        mobile: {
            displaySearchZone: true,
            autoscroll: false
        },
        unifiedSearchEngine: {
            label: "Rechercher sur Orange", toptrend: true,
            queryAdditionalParams: "module=orange&bhv=occ",
            toptrendCategory: "orange.actu",
            tracking: {
                category: "top_search",
                action: "search"
            }
        },
        tracking: {
            refz: {
                service: "acc-digital",
                // page: "regulier-mob"
            },
            Tealium: {
                idBased: true
            }
        },
        footer: {
            id: "footer-wrapper",
            syndicationZone: true,
            sitemapZone: true,
            pushBoutiqueZone: false
        }
    }

    conf['hp'] = {
        infoCookieZone: false,
        oneIMode: true,
        switchMobileToDesktop: {
            activate: true
        },
        genericHeaderZone: false,
        navStickyZone: true,
        searchZone: false,
        noBtnSearch: false,
        unifiedSearchEngine: {
            label: "Rechercher sur Orange",
            queryAdditionalParams: "module=orange&bhv=occ",
            toptrend118712: true,
            toptrend: true,
            toptrendCategory: "orange.actu",
            tracking: {
                category: "top_search",
                action: "search"
            }
        },
        tracking: {
            refz: {
                service: "acc-digital",
                // page: "prospect-nl"
            },
            Tealium: {
                idBased: true
            }
        },
        footer: {
            id: "footer-wrapper",
            syndicationZone: true,
            sitemapZone: true
        }
    }

    conf['hp-mob'] = {
        infoCookieZone: false,
        oneIMode: true,
        genericHeaderZone: true,
        serviceZone: true,
        searchZone: true,
        mobile: {
            displaySearchZone: true,
            autoscroll: false
        },
        unifiedSearchEngine: {
            label: "Rechercher sur Orange", toptrend: true,
            queryAdditionalParams: "module=orange&bhv=occ",
            toptrendCategory: "orange.actu",
            tracking: {
                category: "top_search",
                action: "search"
            }
        },
        tracking: {
            refz: {
                service: "acc-digital",
                // page: "regulier-mob"
            },
            Tealium: {
                idBased: true
            }
        },
        footer: {
            id: "footer-wrapper",
            syndicationZone: true,
            sitemapZone: true
        }
    }

    conf['prospect'] = {
        infoCookieZone: false,
        oneIMode: true,
        switchMobileToDesktop: {
            activate: true
        },
        genericHeaderZone: false,
        navStickyZone: true,
        noBtnSearch: true,
        unifiedSearchEngine: {
            label: "Rechercher sur Orange",
            queryAdditionalParams: "module=orange&bhv=occ",
            toptrend118712: true,
            toptrend: true,
            toptrendCategory: "orange.actu",
            tracking: {
                category: "top_search",
                action: "search"
            }
        },
        tracking: {
            refz: {
                service: "acc-digital",
                // page: "prospect-nl"
            },
            Tealium: {
                idBased: true
            }
        },
        footer: {
            id: "footer-wrapper",
            syndicationZone: true,
            sitemapZone: true
        }
    }

    conf['regulier'] = {
        infoCookieZone: false,
        oneIMode: true,
        switchMobileToDesktop: {
            activate: true
        },
        genericHeaderZone: false,
        navStickyZone: true,
        searchZone: false,
        noBtnSearch: false,
        unifiedSearchEngine: {
            label: "Rechercher sur Orange",
            queryAdditionalParams: "module=orange&bhv=occ",
            toptrend118712: true,
            toptrend: true,
            toptrendCategory: "orange.actu",
            tracking: {
                category: "top_search",
                action: "search"
            }
        },
        tracking: {
            refz: {
                service: "acc-digital",
                // page: "prospect-nl"
            },
            Tealium: {
                idBased: true
            }
        },
        footer: {
            id: "footer-wrapper",
            syndicationZone: true,
            sitemapZone: true
        }
    }

    conf['prospect-regulier-mob'] = {
        infoCookieZone: false,
        oneIMode: true,
        genericHeaderZone: true,
        serviceZone: true,
        searchZone: true,
        mobile: {
            displaySearchZone: true,
            autoscroll: false
        },
        unifiedSearchEngine: {
            label: "Rechercher sur Orange", toptrend: true,
            queryAdditionalParams: "module=orange&bhv=occ",
            toptrendCategory: "orange.actu",
            tracking: {
                category: "top_search",
                action: "search"
            }
        },
        tracking: {
            refz: {
                service: "acc-digital",
                // page: "regulier-mob"
            },
            Tealium: {
                idBased: true
            }
        },
        footer: {
            id: "footer-wrapper",
            syndicationZone: true,
            sitemapZone: true
        }
    }

    conf['occas'] = {
        infoCookieZone: false,
        oneIMode: true,
        switchMobileToDesktop: {
            activate: true
        },
        genericHeaderZone: false,
        navStickyZone: true,
        searchZone: false,
        noBtnSearch: false,
        useCompletion: false,
        unifiedSearchEngine: {
            label: "Rechercher sur Orange",
            toptrend118712: true,
            queryAdditionalParams: "module=orange&bhv=occ",
            toptrend: true,
            toptrendCategory: "orange.actu",
            tracking: {
                category: "top_search",
                action: "search"
            }
        },
        tracking: {
            refz: {
                service: "acc-digital",
                // page: "occas"
            },
            Tealium: {
                idBased: true
            }
        },
        footer: {
            id: "footer-wrapper",
            syndicationZone: true,
            sitemapZone: true
        }
    }

    conf['occas-mob'] = {
        infoCookieZone: false,
        oneIMode: true,
        genericHeaderZone: true,
        serviceZone: true,
        searchZone: true,
        mobile: {
            displaySearchZone: true,
            autoscroll: false
        },
        unifiedSearchEngine: {
            label: "Rechercher sur Orange",
            queryAdditionalParams: "module=orange&bhv=occ",
            toptrend: true,
            toptrendCategory: "orange.actu",
            tracking: {
                category: "top_search",
                action: "search"
            }
        },
        tracking: {
            refz: {
                service: "acc-digital",
                // page: "occas-mob"
            },
            Tealium: {
                idBased: true
            }
        },
        footer: {
            id: "footer-wrapper",
            syndicationZone: true,
            sitemapZone: true
        }
    }

    conf['divert'] = {
        infoCookieZone: false,
        oneIMode: true,
        switchMobileToDesktop: {
            activate: true
        },
        genericHeaderZone: true,
        serviceZone: true,
        domainImg: {
            type: "html",
            src: "<h1 class='my-0 py-0'>TV et divertissement</h1>"
        },
        navStickyZone: true,
        noBtnSearch: true,
        unifiedSearchEngine: {
            label: "Rechercher dans TV et divertissement",
            queryUrl: 'https://lemoteur.orange.fr',
            cmplUrl: "//completion.ke.orange.fr/proxy/cmplsearchbox",
            cmplBlocks: [{ baseId: '-tv' }],
            queryParamName: "kw",
            queryAdditionalParams: "module=chaine&bhv=tv&ap=-1",
            toptrend: false,
            tracking: {
                category: "top_search",
                action: "search"
            }
        },
        tracking: {
            refz: {
                service: "acc-digital",
                // page: "divert-prospect-nl"
            },
            Tealium: {
                profile: "frshoporange",
                idBased: true
            }
        },
        footer: {
            id: "footer-wrapper",
            syndicationZone: true,
            sitemapZone: true
        },
        callbackAccessibility: function () {
        }
    }

    conf['divert-mob'] = {
        infoCookieZone: false,
        oneIMode: true,
        genericHeaderZone: false,
        searchZone: false,
        mobile: {
            displaySearchZone: false,
        },

        unifiedSearchEngine: {
            label: "Rechercher dans TV et divertissement", queryUrl: 'https://lemoteur.orange.fr',
            cmplUrl: "//completion.ke.orange.fr/proxy/cmplsearchbox",
            cmplBlocks: [{ baseId: '-tv' }],
            queryParamName: "kw",
            queryAdditionalParams: "module=chaine&bhv=tv&ap=-1",
            toptrend: false,
            tracking: {
                category: "top_search",
                action: "search"
            }
        },
        tracking: {
            refz: {
                service: "acc-digital",
                // page: "divert-client-mob"
            },
            Tealium: {
                profile: "frshoporange",
                idBased: true
            }
        },
        footer: {
            id: "footer-wrapper",
            syndicationZone: true,
            sitemapZone: true
        }
    }

    conf['divert-mob'] = {
        infoCookieZone: false,
        oneIMode: true,
        genericHeaderZone: false,
        searchZone: false,
        mobile: {
            displaySearchZone: false,
        },
        unifiedSearchEngine: {
            label: "Rechercher dans TV et divertissement",
            queryUrl: 'https://lemoteur.orange.fr',
            cmplUrl: "//completion.ke.orange.fr/proxy/cmplsearchbox",
            cmplBlocks: [{ baseId: '-tv' }],
            queryParamName: "kw",
            queryAdditionalParams: "module=chaine&bhv=tv&ap=-1",
            toptrend: false,
            tracking: {
                category: "top_search",
                action: "search"
            }
        },
        tracking: {
            refz: {
                service: "acc-digital",
                // page: "divert-client-mob"
            },
            Tealium: {
                profile: "frshoporange",
                idBased: true
            }
        },
        footer: {
            id: "footer-wrapper",
            syndicationZone: true,
            sitemapZone: true
        }
    }

    conf['boutique'] = {
        infoCookieZone: false,
        oneIMode: true,
        switchMobileToDesktop: {
            activate: true
        },
        genericHeaderZone: true,
        serviceZone: true,
        domainImg: {
            type: "html",
            src: "<h1 class='my-0 py-0'>Boutique</h1>"
        },
        navStickyZone: true,
        noBtnSearch: true,
        unifiedSearchEngine: {
            label: "Rechercher dans la boutique",
            queryUrl: 'https://lemoteur.orange.fr',
            queryAdditionalParams: 'module=chaine&bhv=boutique',
            cmplBlocks: [{ baseId: '-7' }],
            toptrend: false,
            tracking: {
                category: "header",
                action: "search"
            }
        },
        tracking: {
            refz: {
                service: "acc-digital",
                // page: "boutique"
            },
            Tealium: {
                profile: "frshoporange",
                idBased: true
            }
        },
        footer: {
            id: "footer-wrapper",
            syndicationZone: true,
            sitemapZone: true
        },
        callbackAccessibility: function () {
        }
    }

    conf['boutique-mob'] = {
        infoCookieZone: false,
        oneIMode: true,
        genericHeaderZone: true,
        serviceZone: false,
        searchZone: true,
        mobile: {
            displaySearchZone: true,
            autoscroll: false
        },
        unifiedSearchEngine: {
            label: "Rechercher dans la boutique",
            queryUrl: 'https://lemoteur.orange.fr',
            queryAdditionalParams: 'module=chaine&bhv=boutique',
            cmplBlocks: [{ baseId: '-7' }],
            toptrend: false,
            tracking: {
                category: "top_search",
                action: "search"
            }
        },
        tracking: {
            refz: {
                service: "acc-digital",
                // page: "boutique-mob"
            },
            Tealium: {
                idBased: true
            }
        },
        footer: {
            id: "footer-wrapper",
            syndicationZone: true,
            sitemapZone: true
        }
    }

    return conf[confID]
}
